export default "__VITE_ASSET__JzxEvulY__"